import { Col, Container, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { ControlledSelect } from 'shared/form/components/Select';
import { PageTitle } from 'shared/components/Fonts';
import { useForm, FormProvider } from 'react-hook-form';
import { MovimientosPorTarjetaForm } from '../../components/MovimientosPorTarjetaForm/MovimientosPorTarjetaForm';


interface ReportOption {
  value: string;
  label: string;
}

const REPORT_OPTIONS: ReportOption[] = [
  { value: '', label: 'Seleccione...' },
  { value: 'movimientos-por-tarjeta', label: 'Movimientos por tarjeta' },
  // Agrega aquí otras opciones de reportes en el futuro
];

export const ConsultarReportePage = () => {
  const methods = useForm({
    defaultValues: {
      reportType: REPORT_OPTIONS[0], // El valor por defecto es el objeto completo
    },
  });

  const reportTypeSelection = methods.watch('reportType');
  const reportType = reportTypeSelection?.value ?? '';

  const renderReportForm = () => {

    switch (reportType) {
      case 'movimientos-por-tarjeta':
        return <MovimientosPorTarjetaForm />;
      default:
        return null;
    }
  };

  return (
    <Container fluid>
      <Row className="mb-3 d-flex justify-content-between align-items-center">
        <Col>
          <PageTitle>Consultar Reporte</PageTitle>
        </Col>
      </Row>

      <Card className="mb-4">
        <Card.Title>Reporte</Card.Title>
        <Card.Body $padding>
          <Row>
            <FormProvider {...methods}>
              <form>
                <Col>
                  <ControlledSelect
                    name="reportType"
                    label="Tipo de reporte"
                    options={REPORT_OPTIONS}
                  />
                </Col>
              </form>
            </FormProvider>
          </Row>
        </Card.Body>
      </Card>

      {reportType && (
        <Card className="mb-4">
          <Card.Title>Filtros</Card.Title>
          <Card.Body $padding>
            {renderReportForm()}
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};